export default "__VITE_ASSET__mEXY0gID__"